import Vue from 'vue'
import VueRouter from 'vue-router'
import VueI18n from 'vue-i18n'
import { getCurrentLang, setCurrentLang } from '../common/lang'
//首页
import Home from '../pages/home/index.vue'/* 首页 */
import Mine from '../pages/mine/index.vue'/* 我的 */
import Choose from '../pages/choose/index.vue'/* 选妃 */
import ChooseEntry from '../pages/choose/ChooseEntry.vue'/* 选妃入口 */
import List from '../pages/choose/list.vue'/* 选妃列表 */
import Profile from '../pages/choose/profile.vue'/* 选妃详情 */
import Video from '../pages/video/index.vue'/* 视频 */
import Game from '../pages/game/index.vue'/* 游戏 */
import Login from '../pages/login/index.vue'/* 登录 */
import Register from '../pages/login/register.vue'/* 注册 */
import ServiceOnline from '../pages/mine/ServiceOnline.vue'/* 客服列表 */
import ServicePage from '../pages/mine/ServicePage.vue'/* 客服详情界面 */
import Setting from '../pages/mine/Setting.vue'/* 设置 */
import Infomation from '../pages/mine/Infomation.vue'/* 基本信息 */
import Setname from '../pages/mine/Setname.vue'/* 修改姓名 */
import Language from '../pages/mine/Language.vue'/* 语言选择 */
import Setsex from '../pages/mine/Setsex.vue'/* 修改姓名 */
import Recharge from '../pages/mine/Recharge.vue'/* 充值 */
import SetPayPassword from '../pages/mine/SetPayPassword.vue'/* 修改提现密码 */
import SetLoginPassword from '../pages/mine/SetLoginPassword.vue'/* 修改提现密码 */
import Lottery from '../pages/lottery/index.vue'/* 彩票详情 */
import Notice from '../pages/mine/Notice.vue'/* 公告 */
import PlayVideo  from '../pages/video/PlayVideo'/* 视频播放页面 */
import Setbank  from '../pages/mine/Setbank'/* 视频播放页面 */
import BindCard  from '../pages/mine/BindCard'/* 绑定银行卡界面 */
import Withdraw  from '../pages/mine/Withdraw'/* 绑定银行卡界面 */
import Personalreport  from '../pages/mine/Personalreport'/* 个人表报 */
import GameRecord  from '../pages/mine/GameRecord'/* 游戏记录 */
import WithdrawRecord  from '../pages/mine/WithdrawRecord'/* 提现记录 */
import Details from '../pages/mine/details'

Vue.use(VueRouter)
Vue.use(VueI18n)

// 创建i18n实例
const i18n = new VueI18n({
  locale: setCurrentLang(getCurrentLang()),
  messages: {
    'zh': require('../assets/languages/zh.json'),
    'en': require('../assets/languages/en.json'),
    'ja': require('../assets/languages/ja.json'),
    'kr': require('../assets/languages/kr.json'),
    'de': require('../assets/languages/de.json'),
    'mn': require('../assets/languages/mn.json')
  }
})
const routes = [
    {path:'/',redirect:'/Home',component:Home,meta:{titleKey:'routes.home'}},
    {path:'/Home',name:'home',component:Home,meta:{titleKey:'routes.home'}},
	{path:'/ChooseEntry',name:'chooseEntry',component:ChooseEntry,meta:{titleKey:'routes.choose'}},
	{path:'/Choose',name:'choose',component:Choose,meta:{titleKey:'routes.choose'}},
	{path:'/List',name:'list',component:List,meta:{titleKey:'routes.list'}},
	{path:'/Profile',name:'profile',component:Profile,meta:{titleKey:'routes.profile'}},
    {path:'/Mine',name:'mine',component:Mine,meta:{titleKey:'routes.mine'}},
    {path:'/Video',name:'video',component:Video,meta:{titleKey:'routes.video'}},
    {path:'/Game',name:'game',component:Game,meta:{titleKey:'routes.game'}},
    {path:'/Login',name:'login',component:Login,meta:{titleKey:'routes.login'}},
    {path:'/Register',name:'register',component:Register,meta:{titleKey:'routes.register'}},
    {path:'/ServiceOnline',name:'ServiceOnline',component:ServiceOnline,meta:{titleKey:'routes.service_online'}},
    {path:'/ServicePage',name:'ServicePage',component:ServicePage,meta:{titleKey:'routes.service_page'}},
    {path:'/Setting',name:'Setting',component:Setting,meta:{titleKey:'routes.setting'}},
    {path:'/Infomation',name:'Infomation',component:Infomation,meta:{titleKey:'routes.information'}},
    {path:'/Setname',name:'Setname',component:Setname,meta:{titleKey:'routes.setname'}},
    {path:'/Setsex',name:'Setsex',component:Setsex,meta:{titleKey:'routes.setsex'}},
    {path:'/Language',name:'Language',component:Language,meta:{titleKey:'routes.language'}},
    {path:'/Recharge',name:'Recharge',component:Recharge,meta:{titleKey:'routes.recharge'}},
    {path:'/SetPayPassword',name:'SetPayPassword',component:SetPayPassword,meta:{titleKey:'routes.set_pay_password'}},
    {path:'/SetLoginPassword',name:'SetLoginPassword',component:SetLoginPassword,meta:{titleKey:'routes.set_login_password'}},
    {path:'/Lottery',name:'Lottery',component:Lottery,meta:{titleKey:'routes.lottery'}},
    {path:'/Notice',name:'Notice',component:Notice,meta:{titleKey:'routes.notice'}},
    {path:'/PlayVideo',name:'PlayVideo',component:PlayVideo,meta:{titleKey:'routes.play_video'}},
    {path:'/Setbank',name:'Setbank',component:Setbank,meta:{titleKey:'routes.setbank'}},
    {path:'/BindCard',name:'BindCard',component:BindCard,meta:{titleKey:'routes.bind_card'}},
    {path:'/Withdraw',name:'Withdraw',component:Withdraw,meta:{titleKey:'routes.withdraw'}},
    {path:'/Personalreport',name:'Personalreport',component:Personalreport,meta:{titleKey:'routes.personal_report'}},
    {path:'/WithdrawRecord',name:'WithdrawRecord',component:WithdrawRecord,meta:{titleKey:'routes.withdraw_record'}},
    {path:'/GameRecord',name:'GameRecord',component:GameRecord,meta:{titleKey:'routes.game_record'}},
    {path:'/detail',name:'Details',component:Details,meta:{titleKey:'routes.details'}}

];

//生成路由实例
const router = new VueRouter({
    routes
})
// 更新页面标题的函数
function updateTitle(route) {
    if (route.matched[0] && route.matched[0].meta && route.matched[0].meta.titleKey) {
        document.title = i18n.t(route.matched[0].meta.titleKey)
    }
}

router.beforeEach((to,from,next) => {         //修改标题路由配置加上这个
    // 使用i18n翻译标题
    updateTitle(to)
    next()
})

// 监听语言变化，更新当前页面标题
let currentRoute = null
router.afterEach((to) => {
    currentRoute = to
})

// 监听i18n语言变化
i18n.vm.$watch('locale', () => {
    if (currentRoute) {
        updateTitle(currentRoute)
    }
})

// 导出i18n实例供其他组件使用
export { i18n }
export default router
